/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 & other hashes`)
};

const es_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 y otros hash`)
};

const de_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 & andere Hashes`)
};

const nl_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 en andere hashes`)
};

const fr_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 et autres hash`)
};

const it_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 e altri hash`)
};

const pt_br2_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 e outros hashes`)
};

const pt_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 e outros hashes`)
};

const ja_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256と他のハッシュ`)
};

const zh_hg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA-256 及其他哈希算法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_nav_main_desc", locale)
	if (locale === "en") return en_hg_nav_main_desc(inputs)
	if (locale === "es") return es_hg_nav_main_desc(inputs)
	if (locale === "de") return de_hg_nav_main_desc(inputs)
	if (locale === "nl") return nl_hg_nav_main_desc(inputs)
	if (locale === "fr") return fr_hg_nav_main_desc(inputs)
	if (locale === "it") return it_hg_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_hg_nav_main_desc(inputs)
	if (locale === "pt") return pt_hg_nav_main_desc(inputs)
	if (locale === "ja") return ja_hg_nav_main_desc(inputs)
	return zh_hg_nav_main_desc(inputs)
};